export default __webpack_public_path__ + "images/0x431d5dff03120afa4bdf332c61a6e1766ef37bdb.png";